// src/components/CourseCards.jsx
import React from "react";
import { Link } from "react-router-dom";

/* 🔹 SAME DATA – SINGLE SOURCE OF TRUTH */
const modules = [
  {
    id: 1,
    title: "Accounting",
    subtitle: "Core accounting & bookkeeping",
    shortDesc:
      "Covers day-to-day accounting processes including vouchers, invoicing, reconciliation, depreciation, and inventory. Learners understand P&L, Balance Sheet, Cash Flow, and finalization of books.",
    cardImage: "/images/accounting.png",
  },
  {
    id: 2,
    title: "Income Tax",
    subtitle: "Income tax & compliance",
    shortDesc:
      "Provides complete knowledge of India’s Income Tax system under the Income Tax Act, 1961. Includes tax computation, returns filing, TDS, MAT, deductions, and tax planning.",
    cardImage: "/images/incometax.png",
  },
  {
    id: 3,
    title: "Tally & GST",
    subtitle: "Tally accounting & GST practicals",
    shortDesc:
      "Focuses on practical GST compliance with hands-on Tally ERP training. Covers registration, returns, ITC reconciliation, e-invoicing, and audits.",
    cardImage: "/images/tally&gst.png",
  },
  {
    id: 4,
    title: "MS Excel & Reporting",
    subtitle: "Excel for accounting & analysis",
    shortDesc:
      "Covers essential Excel tools used in accounting and reporting. Includes formulas, pivot tables, dashboards, and MIS reports to improve productivity.",
    cardImage: "/images/msexcel.png",
  },
  {
    id: 5,
    title: "Interview Skills",
    subtitle: "Personality & interviews",
    shortDesc:
      "Improves English communication and interview confidence. Covers presentation skills, teamwork, leadership, and workplace etiquette.",
    cardImage: "/images/interview.png",
  },
  {
    id: 6,
    title: "Banking & Audit",
    subtitle: "Banking, ESI, PF & audit basics",
    shortDesc:
      "Covers banking operations, statutory audits, PF/ESI compliance, and company law basics. Prepares learners for corporate finance and accounting roles.",
    cardImage: "/images/banking&audit.png",
  },
];

export default function CourseCards({ limit }) {
  const visibleCourses = limit ? modules.slice(0, limit) : modules;

  return (
    <section className="cards-grid">
      {visibleCourses.map((course) => (
        <article key={course.id} className="course-card">
          {/* IMAGE */}
          <div className="card-media">
            <img src={course.cardImage} alt={course.title} />
          </div>

          {/* CONTENT */}
          <div className="card-body">
            <h3>{course.title}</h3>
            <p className="card-sub">{course.subtitle}</p>

            {/* 🔥 OXFORD-STYLE 2–3 LINE DESCRIPTION */}
            <p className="card-desc">{course.shortDesc}</p>

            <Link to={`/courses/${course.id}`} className="btn btn-dark">
              Know More
            </Link>
          </div>
        </article>
      ))}
    </section>
  );
}